import { render, staticRenderFns } from "./LatestProductsSection.vue?vue&type=template&id=51a2a21a&"
import script from "./LatestProductsSection.vue?vue&type=script&lang=js&"
export * from "./LatestProductsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports